// extracted by mini-css-extract-plugin
export default {"list":"Items_list__6NCBp","card":"Items_card__y1UnQ","loader":"Items_loader__4VLWf"};